import { install as installI18n } from '~/core/modules/i18n'
import I18nComponentAppLocaleManager from '../components/I18nComponentAppLocaleManager.vue'

export function useComponentI18n(component) {
  const { locale } = useLocale()
  const app = createApp(I18nComponentAppLocaleManager, { component, options: { locale } })
  installI18n(app)
  const root = document.createElement('div')
  const instance = app.mount(root)
  const t = instance.t
  return t
}